import APIUrl from "../../APIUrl";
import axios from "axios";

export const GET_STATS = "GET_STATS";

export function getStatsAction(stats) {
  return { type: GET_STATS, stats: stats };
}

const getExport = (APIUrl, successCallback) => {
  return function (dispatch) {
    return axios
      .get(APIUrl, { responseType: "arraybuffer" })
      .then(function (response) {
        if (response) {
          return successCallback(response);
        }
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const getConnections = function (successCallback) {
  return getExport(APIUrl.getConnections, successCallback);
};

export const getPharmaClients = function (successCallback) {
  return getExport(APIUrl.getPharmaClients, successCallback);
};

export const getPharmaPatients = function (successCallback) {
  return getExport(APIUrl.getPharmaPatients, successCallback);
};

export const getPharmaMercurials = function (successCallback) {
  return getExport(APIUrl.getPharmaMercurials, successCallback);
};

export const getPharmaInterventions = function (successCallback) {
  return getExport(APIUrl.getPharmaInterventions, successCallback);
};

export const getPharmaMaintenances = function (successCallback) {
  return getExport(APIUrl.getPharmaMaintenances, successCallback);
};

export const getPharmaAuditHome = function (successCallback) {
  return getExport(APIUrl.getPharmaAuditHome, successCallback);
};

export const getPharmaAuditDesk = function (successCallback) {
  return getExport(APIUrl.getPharmaAuditDesk, successCallback);
};
